var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { NavigationControl, FullscreenControl } from 'react-map-gl';
// @ts-ignore
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
// @ts-ignore
import MapboxWorker from 'mapbox-gl/dist/mapbox-gl-csp-worker';
// @ts-ignore
mapboxgl.workerClass = MapboxWorker;
import { Map as ReactMapGl } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useMapState, useMapUtils } from '../hooks';
import { useMapConfig } from '../context';
import { useMapBoxRef } from '../context/mapbox-ref-context';
export var MapDefaultProps = {
  chromeWidth: 0,
  style: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #0D1116;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    width: 100%;\n    height: 100%;\n    \n    .gatsby-image-wrapper img {\n      object-fit: contain !important;\n      box-sizing: border-box; !important;\n    };\n  "], ["\n    background: #0D1116;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    width: 100%;\n    height: 100%;\n    \n    .gatsby-image-wrapper img {\n      object-fit: contain !important;\n      box-sizing: border-box; !important;\n    };\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Map = function (props) {
  var className = props.className,
    children = props.children,
    onDragEnd = props.onDragEnd,
    onZoomEnd = props.onZoomEnd,
    onClick = props.onClick,
    onLoad = props.onLoad,
    onInteractionEnd = props.onInteractionEnd,
    style = props.style;
  var init = useMapUtils().init;
  var _a = useMapConfig(),
    mapboxStyleUrl = _a.mapboxStyleUrl,
    mapboxAccessToken = _a.mapboxAccessToken;
  var _b = __read(useMapState(), 3),
    mapState = _b[0],
    setMapState = _b[1],
    patchMapState = _b[2];
  var isInitialized = mapState.isInitialized;
  init();
  var ref = useMapBoxRef();
  return React.createElement(My.Container, {
    className: className
  }, isInitialized && React.createElement(ReactMapGl, __assign({}, mapState, {
    ref: ref,
    onClick: onClick,
    onDragEnd: onInteractionEnd || onDragEnd,
    onZoomEnd: onInteractionEnd || onZoomEnd,
    onMove: function (evt) {
      return patchMapState(evt.viewState);
    },
    mapboxAccessToken: mapboxAccessToken,
    mapStyle: mapboxStyleUrl,
    mapLib: mapboxgl,
    onLoad: onLoad,
    reuseMaps: true,
    doubleClickZoom: false,
    style: style
  }), children, React.createElement(FullscreenControl, {
    position: 'bottom-right'
  }), React.createElement(NavigationControl, {
    position: 'bottom-right',
    showCompass: false
  })));
};
Map.defaultProps = MapDefaultProps;
var templateObject_1, templateObject_2;